import { Form } from "components/styleguide";
import DatePickerAvailableDaysWrapper from "components/styleguide/components/DatePickerAvailableDaysWrapper";
import { ForumResponseModel } from "generated/api";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";

const DateFilterForm = () => {
  const { t } = useTranslation();

  const { forum } = useOutletContext<{ forum: ForumResponseModel }>();

  return (
    <Form.Item
      name="dateRange"
      label={t("Dates")}
      rules={[{ required: true, message: t("errors.required", { prop: "$t(Date Range)" }) }]}
      initialValue={[moment(forum?.startDate), moment(forum?.endDate)]}
    >
      <DatePickerAvailableDaysWrapper.RangePickerAvailableDaysWrapper
        style={{ width: "100%" }}
        defaultPickerValue={[moment(forum.startDate), moment(forum.endDate)]}
        availableDatesGetterType="TwelveMonthsBeforeEndOfEvent"
        eventStartDate={moment(forum.startDate)}
        eventEndDate={moment(forum.endDate)}
      />
    </Form.Item>
  );
};

export default DateFilterForm;
